import { IconBase, IconProps } from '../base/IconBase';

export const PinDropIcon = (props: IconProps) => {
	const { variant = 'rounded', ...rest } = props;

	const renderPaths = () => {
		switch (variant) {
			case 'rounded':
				return (
					<path d="M480-200Q339-304 269.5-402T200-594q0-125 78-205.5T480-880q124 0 202 80.5T760-594q0 94-69.5 192T480-200Zm0-320q33 0 56.5-23.5T560-600q0-33-23.5-56.5T480-680q-33 0-56.5 23.5T400-600q0 33 23.5 56.5T480-520ZM200-80v-80h560v80H200Z"/>
				);

			case 'filled':
				return (
					<path d="M480-205Q344-307 277-406t-67-190.5q0-120 75.5-196.75T480-870q119 0 194.5 76.75T750-596.5q0 91.5-67 190.5T480-205Zm0-315q33 0 56.5-23.5T560-600q0-33-23.5-56.5T480-680q-33 0-56.5 23.5T400-600q0 33 23.5 56.5T480-520ZM210-90v-75h540v75H210Z" />
				);

			default:
				return null;
		}
	};

	return <IconBase {...rest}>{renderPaths()}</IconBase>;
};
